import { render, staticRenderFns } from "./EditContentDomainModal.vue?vue&type=template&id=2da4487c&lang=pug&"
import script from "./EditContentDomainModal.vue?vue&type=script&lang=js&"
export * from "./EditContentDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports